import { useUnbiasedProfileName } from "PFCore/hooks/use_unbiased_profile_name";
import { Profile } from "PFTypes";
import { SyntheticEvent } from "react";
import { Link } from "react-router";

import css from "./profile_card_name.module.scss";

type ProfileCardNameProps = {
  href?: string;
  isUnbiasedMode?: boolean;
  name: string;
  onClick?: (e: SyntheticEvent) => void;
  profile: Profile;
  qaId?: string;
};

const ProfileCardName = ({
  href,
  isUnbiasedMode,
  profile,
  name,
  onClick,
  qaId = "ProfileCard.name"
}: ProfileCardNameProps) => {
  const { getUnbiasedProfileName } = useUnbiasedProfileName();
  const nameNode = (
    <strong className={css.name} title={name.length > 70 ? name : undefined}>
      {name}
    </strong>
  );

  if (isUnbiasedMode) {
    return <div className={css.name}>{getUnbiasedProfileName(profile, isUnbiasedMode)}</div>;
  }
  if (href) {
    return (
      <Link to={href} data-qa-id={qaId} onClick={onClick}>
        {nameNode}
      </Link>
    );
  }

  return nameNode;
};

export default ProfileCardName;
